// Animation system — calm authority (120–320ms, smooth ease-out)
export const motion = {
  ease: 'cubic-bezier(0.22, 0.61, 0.36, 1)',
  duration: {
    fast: 120,
    base: 200,
    slow: 320,
  },
} as const

export type Motion = typeof motion
